import episode01 from './episode-01.webp';
import episode02 from './episode-02.webp';
import episode03 from './episode-03.webp';
import episode04 from './episode-04.webp';
import episode05 from './episode-05.webp';
import episode06 from './episode-06.webp';
import episode07 from './episode-07.webp';
import episode08 from './episode-08.webp';
import episode09 from './episode-09.webp';
import episode10 from './episode-10.webp';
import episode11 from './episode-11.webp';
import episode12 from './episode-12.webp';
import episode13 from './episode-13.webp';
import episode14 from './episode-14.webp';
import episode15 from './episode-15.webp';
import episode16 from './episode-16.webp';

/**
 * Podcast artwork, keyed by the filename stored on the podcast record.
 *
 * The API only carries the *name* of the image — the bytes live here, in the
 * client bundle, so the list response stays small and the browser serves the
 * artwork from its static asset cache. Add a file here (and reference its name
 * from the podcast document) to introduce a new episode image; anything the
 * server names but this map doesn't have falls back to the shared placeholder.
 */
export const podcastImages: Record<string, string> = {
  'episode-01.webp': episode01,
  'episode-02.webp': episode02,
  'episode-03.webp': episode03,
  'episode-04.webp': episode04,
  'episode-05.webp': episode05,
  'episode-06.webp': episode06,
  'episode-07.webp': episode07,
  'episode-08.webp': episode08,
  'episode-09.webp': episode09,
  'episode-10.webp': episode10,
  'episode-11.webp': episode11,
  'episode-12.webp': episode12,
  'episode-13.webp': episode13,
  'episode-14.webp': episode14,
  'episode-15.webp': episode15,
  'episode-16.webp': episode16,
};
